import React from 'react'
import { Tag } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

interface DeviceStatusTagProps {
  isOnline: boolean
  compact?: boolean
}

const DeviceStatusTag: React.FC<DeviceStatusTagProps> = ({ isOnline, compact }) => {
  if (compact) {
    return isOnline ? (
      <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 16 }} />
    ) : (
      <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: 16 }} />
    )
  }
  
  return isOnline ? (
    <Tag icon={<CheckCircleOutlined />} color="success">
      在线
    </Tag>
  ) : (
    <Tag icon={<CloseCircleOutlined />} color="error">
      离线
    </Tag>
  )
}

export default DeviceStatusTag
